import { locStor } from './localStorageManagement.js'
import { global } from './global.js'
import Vue from 'vue'

export const appData = {
  state: {
    types: [{
      id: 'corn',
      title: 'Corn',
      class: 'corn',
      Sliders: [],
      Selects: [],
      selectedMax: null,
      selectedMin: null,
      selectedOptions: []
    },
    {
      id: 'soybeans',
      title: 'Soybeans',
      class: 'soybeans',
      Sliders: [],
      Selects: [],
      selectedMax: null,
      selectedMin: null,
      selectedOptions: []
    },
    {
      id: 'wheat',
      title: 'Wheat',
      class: 'wheat',
      Sliders: [],
      Selects: [],
      selectedMax: null,
      selectedMin: null,
      selectedOptions: []
    },
    {
      id: 'alfalfa',
      title: 'Alfalfa',
      class: 'alfalfa',
      Sliders: [],
      Selects: [],
      selectedMax: null,
      selectedMin: null,
      selectedOptions: []
    },
    {
      id: 'sorghum',
      title: 'Sorghum',
      class: 'sorghum',
      Sliders: [],
      Selects: [],
      selectedMax: null,
      selectedMin: null,
      selectedOptions: []
    },
    {
      id: 'smallgrain',
      title: 'Small Grains',
      class: 'other',
      Sliders: [],
      Selects: [],
      selectedMax: null,
      selectedMin: null,
      selectedOptions: []
    }],
    employees: [],
    products: [],
    companyHistory: '',
    legal: '',
    showUpdateAlert: false
  },
  updateEmployees(employees) {
    this.state.employees.length = 0;
    employees.forEach(e => {
      this.state.employees.push(e);
    });
    if(global.IS_APP) {
      locStor.saveEmployees(this.state.employees);
    }
  },
  updateProducts(products) {
    this.state.products.length = 0;
    products.forEach(e => {
      this.state.products.push(e);
    });
    if(global.IS_APP) {
      locStor.saveProducts(this.state.products);
    }
  },
  toggleFavorite(product) {
    let selectedProduct = this.state.products.filter(p => product.Name === p.Name)[0];
    selectedProduct.fav = !selectedProduct.fav;
    if(global.IS_APP) {
      locStor.saveProducts(this.state.products);
    }
  },
  updateCompanyHistory(html) {
    this.state.companyHistory = html;

    if(global.IS_APP) {
      locStor.saveCompanyHistory(this.state.companyHistory);
    }
  },
  updateLegal(html) {
    this.state.legal = html;
    if(global.IS_APP) {
      locStor.saveLegal(this.state.legal);
    }
  },
  updateUpdateAlert(show) {
    this.state.showUpdateAlert = show;
    if(this.state.showUpdateAlert) {
      let element = document.getElementsByClassName("fa-bell-o")[0];
      element.classList.add("ring");
    } else {
      let element = document.getElementsByClassName("fa-bell-o")[0];
      element.classList.remove("ring");
    }
  },
  updateType(type) {
    let selectedType = this.state.types.filter(t => t.id === type.id)[0];
    Object.assign(selectedType, type);
  },
  updateAllTypes(types) {
    types.forEach(type => {
      let selectedType = this.state.types.filter(t => t.id === type.id)[0];
      Object.assign(selectedType, type);
    });
    if(global.IS_APP) {
      locStor.saveTypes(this.state.types);
    }
  },
  resetTypeFilters() {
    this.state.types.forEach(type => {
      type.selectedMin = null;
      type.selectedMax = null;
      type.selectedOptions.length = 0;
    });
  }
};



// WEBPACK FOOTER //
// ./src/data.js